import React, {useEffect, useRef, useState} from 'react';
import { Row, Col, Card, Button, Form } from 'react-bootstrap';
import {add, listUnused} from '../../../lib/api/competitionClubs';

export function Add({ initialData, onClose, onSave }) {
  const [competition, setCompetition] = useState(initialData);
  const [clubs, setClubs] = useState([]);

  useEffect(() => {
    (async () => {
      const resClubs = await listUnused(competition.competitions_guid);
      console.log('resClubs',resClubs)
      setClubs(resClubs);
    })();
  }, [competition]);

  const handleSubmit = async event => {
    event.preventDefault();
    const form = event.currentTarget;
    const formData = new FormData(event.currentTarget);
    const obj = Object.fromEntries(formData.entries());
    const selected = Object.keys(obj)
        .filter(key => obj[key] === 'true')
        .map(Number);

    if (selected.length === 0) return
    await add({"club_entities_ids": selected}, competition.competitions_guid);
    onSave();
    onClose();
  };

  return (
      <Card>
        <Card.Body className="bg-body-tertiary">
          <Form
              method="POST"
              encType="multipart/form-data"
              noValidate
              onSubmit={handleSubmit}
          >
            <Row className="mb-3">
              <Form.Group as={Col} md="12" controlId="clubs-list">
                <Form.Label as="legend" column md="12" className="mb-3">
                  Klubovi
                </Form.Label>
                <Row>
                  <Col md={6}>
                    {clubs.filter((_, i) => i % 2 === 0).map((item, i) => (
                        <div className="form-check" key={item.entities_id}>
                          <input
                              className="form-check-input"
                              type="checkbox"
                              name={item.entities_id}
                              value={true}
                              id={item.entities_id}
                          />
                          <label className="form-check-label" htmlFor={`check_${item.entities_id}`}>
                            {item.clubs_name}
                          </label>
                        </div>
                    ))}
                  </Col>
                  <Col md={6}>
                    {clubs.filter((_, i) => i % 2 !== 0).map((item, i) => (
                        <div className="form-check" key={item.entities_id}>
                          <input
                              className="form-check-input"
                              type="checkbox"
                              name={item.entities_id}
                              value={true}
                              id={item.entities_id}
                          />
                          <label className="form-check-label" htmlFor={`check_${item.entities_id}`}>
                            {item.clubs_name}
                          </label>
                        </div>
                    ))}
                  </Col>
                </Row>
              </Form.Group>
            </Row>



            <Button type="submit">Sačuvaj</Button>
          </Form>
        </Card.Body>
      </Card>
  );
}
